import OriginalMedia from './Media.svelte';
import Avatar from './Avatar.svelte';
import OriginalContent from './Content.svelte';
import Description from './Description.svelte';
import Title from './Title.svelte';
const Media = OriginalMedia;
Media.Avatar = Avatar;
Media.Content = OriginalContent;
Media.Content.Title = Title;
Media.Content.Description = Description;
export default Media;
